import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/aggregation_loan_forgiveness_observation_resource.rb
// Registered from the systemic missing-schema audit (the #9130/#8988 class:
// an API-emittable JSON:API type the FE manifest never registered).
// Super-admin-only; parent aggregation-loan resolves lazily via LegacyMode.
const AggregationLoanForgivenessObservationSchema = withDefaults({
  type: 'aggregation-loan-forgiveness-observation',
  fields: [
    { kind: 'attribute', name: 'at' },
    { kind: 'attribute', name: 'detail' },
    { kind: 'attribute', name: 'ineligible' },
    { kind: 'attribute', name: 'potential' },
    { kind: 'attribute', name: 'program' },
    { kind: 'attribute', name: 'provider' },
    { kind: 'attribute', name: 'qualified' },
    { kind: 'attribute', name: 'unqualified' },
    {
      kind: 'belongsTo',
      name: 'aggregationLoan',
      type: 'aggregation-loan',
      options: { async: false, inverse: null },
    },
  ],
});

export default AggregationLoanForgivenessObservationSchema;
